<script lang="ts" setup>
import BaseVGrid from "@/components/BaseVGrid.vue";

const props = defineProps<{
  zeitbereich?: APIZeitbereich;
  queryAic?: number;
}>();
</script>
<template>
  <BaseVGrid
    query="RK_Fehlermeldungen_Anzeige"
    :zeitbereich="zeitbereich"
    :queryAic="queryAic"
    :showClose="false"
    :hideWhenEmpty="true"
  ></BaseVGrid>
</template>
